import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { CURRENCY_CODE, PN_SUMARY_STATEMENT_TYPE } from "../../utils/Utils";

const PN_SUMARY_STATEMENT_TYPE_OPTIONS = Object.keys(PN_SUMARY_STATEMENT_TYPE).map((c) => ({
  label: PN_SUMARY_STATEMENT_TYPE[c],
  value: c,
}));

const DEFAULT_SUMMARY = {
  id: null,
  type: "CUSTOMER",
  key: "",
  value: '',
};

const PNSummaryStatementManager = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditedId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [deleteId, setDeleteId] = useState();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [pnBankAccountOptions, setPNBankAccountOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });
  const [filter, setFilter] = useState({
    type: searchParams.get("type") || 'CUSTOMER',
  });

  useEffect(() => {
    GET("/pn-customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          } || [])
        )
      );
    });
    GET(`/pn-bank-account`, {}, true)
      .then(({ data }) => {
        setPNBankAccountOptions(data.map(c => ({
          label: c.name,
          value: c.id,
          data: c
        })))
      })
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
    GET("/user/list-drivers", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setDriverOptions(
          data.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });

  }, []);
  const generateName = (item) => {
    switch (item.type) {
      case 'BANK_ACCOUNT':
      case 'BANK_ACCOUNT_USD':
        return pnBankAccountOptions.find(e => +e.data.id === +item.key)?.data?.name || item.key
      case 'CUSTOMER':
        return customerOptions.find(e => e.data.id === item.key)?.data?.name || item.key
      case 'DRIVER_COST_ADVANCE':
        return driverOptions.find(e => +e.data.id === +item.key)?.data?.name || item.key
      case 'PRICE_OIL':
      case 'PRICE_PETROLEUM':
      case 'PRICE_HYDRAULIC_PETROLEUM':
      case 'PRICE_GAS':
      case 'QUANTITY_OIL':
      case 'QUANTITY_PETROLEUM':
      case 'QUANTITY_HYDRAULIC_PETROLEUM':
      case 'QUANTITY_GAS':
        return item.key
      default:
        return item.key
    }
  }
  const colTable = [
    {
      Header: "loại",
      accessor: (item) => PN_SUMARY_STATEMENT_TYPE[item.type],
    },
    {
      Header: "Tên",
      accessor: (item) => generateName(item),
    },
    {
      Header: "Giá trị",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          value={item.value}
          displayType={"text"}
          decimalScale={2}
          thousandSeparator={","}
          thousandsGroupStyle="thousand"
        />
      ),
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
    watch,
  } = useForm({
    defaultValues: DEFAULT_SUMMARY,
  });

  useEffect(() => {
    const newParams = new URLSearchParams({
      type: filter.type,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    let params = {
      ...(filter.type ? { type: filter.type } : {})
    };

    GET(`/pn/get-first-summary-statement`, params, true)
      .then(({ data }) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset({
      ...DEFAULT_SUMMARY
    })
    setEditedId();
    setDeleteId();
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/pn/get-first-summary-statement/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { type, key, value } = getValues();
    const request = editId
      ? PUT(
        `/pn/get-first-summary-statement/${editId}`,
        {
          type, key: `${key}`, value: Number(value)
        },
        {},
        true
      )
      : POST("/pn/get-first-summary-statement", {
        type, key: `${key}`, value: Number(value)
      }, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onDelete = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/pn/get-first-summary-statement/${id}`, {}, true)
      .then(() => {
        toast.success("Xóa thành công");
        resetData();
        setTimeNow(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const type = watch('type');
  return (
    <React.Fragment>
      <Head title="Quản lý đầu kỳ"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đầu kỳ</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          placeholder="Chọn Loại"
                          classNamePrefix="form-control"
                          options={PN_SUMARY_STATEMENT_TYPE_OPTIONS}
                          value={PN_SUMARY_STATEMENT_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: val?.value || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm đầu kỳ</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm đầu kỳ</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Loại
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="type"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <ReactSelect
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={PN_SUMARY_STATEMENT_TYPE_OPTIONS}
                                value={PN_SUMARY_STATEMENT_TYPE_OPTIONS.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => {
                                  onChange(val.value)
                                  setValue('key', '')
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="type"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tên
                          <span className="text-danger">*</span>
                        </label>

                        <div className="form-control-wrap">
                          {type === 'CUSTOMER'
                            ? <Controller
                              control={control}
                              name="key"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, name, ref }) => (
                                <ReactSelect
                                  classNamePrefix="form-control"
                                  inputRef={ref}
                                  name={name}
                                  options={customerOptions}
                                  value={customerOptions.find(
                                    (c) => c.value === value
                                  ) || null}
                                  onChange={(val) => onChange(val.value)}
                                />
                              )}
                            /> : type === 'DRIVER_COST_ADVANCE'
                              ? <Controller
                                control={control}
                                name="key"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <ReactSelect
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={driverOptions}
                                    value={driverOptions.find(
                                      (c) => c.value === value
                                    ) || null}
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              /> : type === 'BANK_ACCOUNT'
                              ? <Controller
                                control={control}
                                name="key"
                                rules={{ required: "Vui lòng nhập thông tin" }}
                                render={({ onChange, value, name, ref }) => (
                                  <ReactSelect
                                    classNamePrefix="form-control"
                                    inputRef={ref}
                                    name={name}
                                    options={pnBankAccountOptions}
                                    value={pnBankAccountOptions.find(
                                      (c) => c.value === value
                                    ) || null}
                                    onChange={(val) => onChange(val.value)}
                                  />
                                )}
                              /> : type === 'BANK_ACCOUNT_USD'
                                ? <Controller
                                  control={control}
                                  name="key"
                                  rules={{ required: "Vui lòng nhập thông tin" }}
                                  render={({ onChange, value, name, ref }) => (
                                    <ReactSelect
                                      classNamePrefix="form-control"
                                      inputRef={ref}
                                      name={name}
                                      options={pnBankAccountOptions.filter(e => e.data.currencyCode === CURRENCY_CODE.USD)}
                                      value={pnBankAccountOptions.find(
                                        (c) => c.value === value
                                      ) || null}
                                      onChange={(val) => onChange(val.value)}
                                    />
                                  )}
                                />
                                : [
                                  'PRICE_OIL',
                                  'PRICE_PETROLEUM',
                                  'PRICE_HYDRAULIC_PETROLEUM',
                                  'PRICE_GAS',
                                  'QUANTITY_OIL',
                                  'QUANTITY_PETROLEUM',
                                  'QUANTITY_HYDRAULIC_PETROLEUM',
                                  'QUANTITY_GAS',
                                ].includes(type)
                                  ? <Controller
                                    control={control}
                                    name="key"
                                    rules={{ required: "Vui lòng nhập thông tin" }}
                                    render={({ onChange, value, name, ref }) => (
                                      <Input type="text" value={value} onChange={(e) => onChange(e.target.value)} />
                                    )}
                                  />
                                  : <></>
                          }

                          <ErrorMessage
                            errors={errors}
                            name="type"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="interestRate">
                          Giá trị
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="value"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                placeholder="10"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="value"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Xác nhận</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá khoản vay này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    onDelete(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default PNSummaryStatementManager;
